module.exports = __webpack_public_path__ + "img/section4Logo2.bd3a09b2.webp";